import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { adminAction } from '../../../redux/common/action'
import { toast } from 'react-toastify'
import { Form } from 'react-bootstrap'

function TestPage() {
  const dispatch = useDispatch();
  const defaultObj = {
    time_hydrent_to_filling_start: '',
    new_booking_time: ''
  }
  const [data, setData] = React.useState(defaultObj);

  const get_dashboard: any = useSelector((state: any) =>
    state.admin.get_dashboard ? state.admin.get_dashboard : {}
  );

  const get_booking_details: any = useSelector((state: any) =>
    state.admin.get_booking_time_details ? state.admin.get_booking_time_details : {}
  )

  useEffect(() => {
    // dispatch(adminAction.getPermissionsList('dhsg'))
    dispatch(adminAction.dashboard(1));
    dispatch(adminAction.getBookingTimeData());
    // dispatch(adminAction.getRoleList(''))
    // dispatch(adminAction.getgetAllCircles(''))
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => { }
  }, [])

  useEffect(() => {
    if (get_booking_details && Object.keys(get_booking_details)?.length > 0) {
      setData({
        time_hydrent_to_filling_start: get_booking_details.time_hydrent_to_filling_start,
        new_booking_time: get_booking_details.new_booking_time
      })
    }
  }, [get_booking_details])
  const handleTextChange = (e: any, name: string) => {
    setData({ ...data, [name]: parseInt(e.target.value) });
  }

  const handleSubmit = () => {
    if (!data.time_hydrent_to_filling_start || !data.new_booking_time) {
      toast.error("Please fill all fields");
      return;
    }
    const newData = new FormData();
    newData.append("time_hydrent_to_filling_start", data.time_hydrent_to_filling_start);
    newData.append("new_booking_time", data.new_booking_time);
    dispatch(adminAction.setBookingAppTime(newData));
  }
  return (
    <div>
      <div className='row justify-content-between align-items-center'>
        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking?status=Pending'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#7ABAEB' }}
          >
            <p>{get_dashboard?.pending ? get_dashboard?.pending : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Waiting For Driver</h6>
          </Link>
        </div>

        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking?status=Accepted'}
            className=' text-center nevBoxco'
            style={{ backgroundColor: '#AFDDF4' }}
          >
            <p>{get_dashboard?.accepted ? get_dashboard?.accepted : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Driver Accepted</h6>
          </Link>
        </div>

        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking?status=Going-To-FillingStation'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#F4E778' }}
          >
            <p>{get_dashboard?.going_filling_station ? get_dashboard?.going_filling_station : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Going To Station</h6>
          </Link>
        </div>

        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking?status=Arrived-To-FillingStation'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#A995CD' }}
          >
            <p>{get_dashboard?.arrived_hydrent ? get_dashboard?.arrived_hydrent : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Reached Hydrent</h6>
          </Link>
        </div>

        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking?status=Going-To-Destination'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#E8B86D' }}
          >
            <p>{get_dashboard?.on_going ? get_dashboard?.on_going : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} On Going</h6>
          </Link>
        </div>

        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking?status=Going-To-Destination'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#F6EACB' }}
          >
            <p>{get_dashboard?.otp_pending ? get_dashboard?.otp_pending : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Customer Otp Pending</h6>
          </Link>
        </div>
        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking?status=Arrived-To-Destination'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#F6EACB' }}
          >
            <p>{get_dashboard?.arrived_destination ? get_dashboard?.arrived_destination : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Arrived Destination</h6>
          </Link>
        </div>

        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking?status=Filling-Started'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#A1D6B2' }}
          >
            <p>{get_dashboard?.water_supply_started ? get_dashboard?.water_supply_started : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Water Supply Start</h6>
          </Link>
        </div>

        <div className='col-md-3 col-6'>
          <Link
            to={'/complete-booking?date=currentDate'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#97BE5A' }}
          >
            <p>{get_dashboard?.completed ? get_dashboard?.completed : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Completed </h6>
          </Link>
        </div>
        <div className='col-md-3 col-6'>
          <Link
            to={'/cancel-booking?date=currentDate'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#FFAAAA' }}
          >
            <p>{get_dashboard?.cancelled ? get_dashboard?.cancelled : 0}</p>
            <h6> Cancelled</h6>
          </Link>
        </div>
        <div className='col-md-3 col-6'>
          <Link
            to={'/vehicles'}
            className=' text-center nevBoxco'
            style={{ backgroundColor: '#DAD3BE' }}
          >
            <p>{get_dashboard?.total_tanker ? get_dashboard?.total_tanker : 0}</p>
            <h6> Total Tanker</h6>
          </Link>
        </div>
        <div className='col-md-3 col-6'>
          <Link
            to={'/all-booking'}
            className='  text-center nevBoxco'
            style={{ backgroundColor: '#36BA98' }}
          >
            <p>{get_dashboard?.total_booking ? get_dashboard?.total_booking : 0}</p>
            <h6> {moment(new Date()).format('ddd MMM DD')} Total Booking</h6>
          </Link>
        </div>
        {/* <div className='col-6'>
          <Link to={'/permission'} className='bg-primary text-center nevBoxco'>
            <h5 className='text-light'>Permission</h5>
          </Link>
        </div>
        <div className='col-6'>
          <Link to={'/circle'} className='bg-success text-center nevBoxco'>
            <h5 className='text-light'>Circle</h5>
          </Link>
        </div>
        <div className='col-6'>
          <Link to={'/rate'} className='bg-danger text-center nevBoxco'>
            <h5 className='text-light'>Rate</h5>
          </Link>
        </div>
        <div className='col-6'>
          <Link to={'/user-list'} className='bg-warning text-center nevBoxco'>
            <h5 className='text-light'>User List</h5>
          </Link>
        </div> */}
      </div>

      <div className="card border-0 shadow-sm p-4 mt-4">
        <div className="row g-3 align-items-end">
          <div className="col-md-4">
            <label className="form-label fw-semibold">New Booking Time (minutes)</label>
            <input
              className='form-control form-control-solid'
              placeholder='Enter Booking time'
              name='name'
              type='number'
              value={data.new_booking_time}
              onChange={(e: any) => {
                handleTextChange(e, 'new_booking_time')
              }}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label fw-semibold">Hydrant - Filling start time (minutes)</label>
            <input
              className='form-control form-control-solid'
              placeholder='Enter Hydrant time'
              name='name'
              type='number'
              value={data.time_hydrent_to_filling_start}
              onChange={(e: any) => {
                handleTextChange(e, 'time_hydrent_to_filling_start')
              }}
            />
          </div>
          <div className="col-md-3">
            <button onClick={handleSubmit} className="btn btn-success w-100">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestPage
